import { Link } from 'react-router-dom';
import { TermsContent } from '../../components/legal/TermsContent';

export function TermsPage() {
  return (
    <div className="min-h-dvh bg-app-bg">
      <div className="max-w-2xl mx-auto px-4 py-8">
        <Link to="/" className="text-sm text-gold underline underline-offset-2 mb-4 inline-block">&larr; Back</Link>
        <h1 className="font-serif text-3xl text-app-fg mb-6">Terms of Service</h1>
        <TermsContent />
      </div>
    </div>
  );
}

export default TermsPage;
